/**
 * @flow
 * @relayHash a48153b661240cf9ad3d8ec31ce88d7f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GenerateZipInput = {|
  eventId: string,
  type: string,
|};
export type GenerateZipMutationVariables = {|
  input: GenerateZipInput
|};
export type GenerateZipMutationResponse = {|
  +generateZip: ?{|
    +url: ?string
  |}
|};
export type GenerateZipMutation = {|
  variables: GenerateZipMutationVariables,
  response: GenerateZipMutationResponse,
|};
*/


/*
mutation GenerateZipMutation(
  $input: GenerateZipInput!
) {
  generateZip(input: $input) {
    url
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "GenerateZipInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "generateZip",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateZipPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GenerateZipMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GenerateZipMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GenerateZipMutation",
    "id": null,
    "text": "mutation GenerateZipMutation(\n  $input: GenerateZipInput!\n) {\n  generateZip(input: $input) {\n    url\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c834f74d8964127c0a30bb5de88f4a7e';

module.exports = node;
